module.exports = __webpack_public_path__ + "static/leonard-cohen-e0a16d645de45f206bda383e3d617162.jpg";